
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcDamper as ObcDamperElement} from '@oicl/openbridge-webcomponents/dist/automation/damper/damper.js';
 
 
 

 
 export const ObcDamper = createComponent({
   react: React,
   tagName: 'obc-damper',
   elementClass: ObcDamperElement,
   events: {
     
   }
  });
 
 